export const spotifyPlayerMetadata = {
    isRepeatable: false
}
